import axios from '@axios'

const PREFIX = '/proprietarios'

export default {

  getProprietario() {
    return axios.get(`${PREFIX}`)
  },

  updateProprietario(proprietario) {
    return axios.post(`${PREFIX}`, proprietario)
  },
}
